import { Injectable } from '@angular/core';
import { uniqueId } from 'lodash-es';
import { IAdapter } from 'src/app/models';
import { UnitsOfMeasure } from 'src/app/models/domain';
import { YPMUOMVCDSYPMUOMVType } from 'src/generated-clients/uom';

@Injectable({
  providedIn: 'root',
})
export class UnitsOfMeasureAdapter implements IAdapter<UnitsOfMeasure, YPMUOMVCDSYPMUOMVType> {
  public adaptToDomain(uomResponse: YPMUOMVCDSYPMUOMVType): UnitsOfMeasure {
    return new UnitsOfMeasure(
      uniqueId(), // uom lacks a good unique id, so we generate one
      uomResponse.materialNumber ?? '',
      uomResponse.altUnit ?? '',
      Number(uomResponse.length),
      Number(uomResponse.width),
      Number(uomResponse.height),
      uomResponse.unitOfDimension ?? '',
      Number(uomResponse.volume),
      uomResponse.volumeUnit ?? '',
      Number(uomResponse.grossWeight),
      uomResponse.weightUnit ?? ''
    );
  }
}
